import React from 'react';
import AbstractCustomFormInput from 'root/libs/exaforte/react/abstracts/form/AbstractCustomFormInput';
import _ from 'root/libs/exaforte/react/lodash';
import { InputLabel, FormHelperText } from '@material-ui/core';
import { FieldSet } from 'root/globals/Form';

export default class CustomFormInput extends AbstractCustomFormInput {
    static ignorePropsOnComponentUpdateCheck() {
        return ['wrapper', 'onChangeText'];
    }

    render() {
        let element = this.getElement();
        
        if(_.is_empty(element))
            return null;
        
        let props           = this.getSupportedProps();
        let mandatorySign   = this.props.mandatorySign || ' *';
        let shrinkLabel     = this.props.shrinkLabel || false;
        let Wrapper         = this.props.wrapper || FieldSet;

        return <Wrapper data-error={!_.is_empty(this.props.error)} data-label={!_.is_empty(this.props.label)}>
            {(!_.is_empty(this.props.label) && <InputLabel shrink={shrinkLabel} data-mandatory={this.props.mandatory} htmlFor={this.props.field}>{this.props.label}{this.props.mandatory === true && mandatorySign}</InputLabel>)}
            {this.props.description && <FormHelperText>{this.props.description}</FormHelperText>}
            {element}
            {this.props.error && <FormHelperText error={true}>{this.props.error}</FormHelperText>}
        </Wrapper>;
    }
}